module.exports = __webpack_public_path__ + "static/media/dark.cff6190b.png";